'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */

import React from 'react';
import { FeLink } from '../../../components/FeLink';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { NavigationItemLevel2 } from '../types';
import { navbarLinkToUrl } from '../utils/utils';
import LinkItem from './LinkItem';

interface LinkGroupProps {
  index_level_one: number | string;
  pushDataLayer: PushDataLayerFn;
}

const LinkGroup: React.FC<LinkGroupProps & NavigationItemLevel2> = (props) => {
  const { langPrefix, brand } = useCmsClientContext();
  const { index_level_one, pushDataLayer, ...link } = props;
  const { text, href, url_target } = navbarLinkToUrl(link!, {
    langPrefix,
    brand,
  });
  return (
    <div className="pl-8 pt-5">
      <FeLink
        href={href}
        target={url_target}
        className="font-bold text-[#212529] text-[16px]"
      >
        {text}
      </FeLink>
      <div className="flex flex-col gap-2 pt-5 text-[16px]">
        {link?.sublinks?.map((sublink, index) => {
          const { text: subText, href } = navbarLinkToUrl(sublink!, {
            brand,
            langPrefix,
          });
          return (
            <LinkItem
              key={`${index_level_one}.${text}.${subText}.${href}`}
              index={`${index_level_one}.${index}`}
              sectionTitle={text}
              pushDataLayer={pushDataLayer}
              {...sublink!}
            />
          );
        })}
      </div>
    </div>
  );
};

export default LinkGroup;
